function wineshippingboxesApp() {
    var app = this;
    app.api = {
        url: 'https://shopify.pospaper.com/'
    };
    app.endpoint = 'https://wineshippingboxesApp-com.myshopify.com/api/2021-01/graphql.json';
    app.headers = {"X-Shopify-Storefront-Access-Token": "310583737f158a27a60f546629e23f26"};
    app.productData = {
        tierPrices: []
    };

    this.init = function () {
        app.events();
        app.product();
        app.qty();
    };

    this.events = function () {
        $('.site-header-contact-link').hover(
            function () {
                $(this).addClass('open');
            },
            function () {
                $(this).removeClass('open');
            });

        $('body').on('click', '.learn-more-link,.tooltip-close', function (e) {
            e.preventDefault();
            $(this).closest('.tooltip-wrapper').toggleClass('open');
        });
    };

    this.qty = function () {
        $('[data-quantity-wrapper]').on('click','input[type="button"]',function (e) {
            e.preventDefault();
            var qtyInput = $(this).closest('.form-field').find('input[type="number"]'),
                qty = 0,
                origQty = parseInt(qtyInput.val()),
                minAllowed = qtyInput.attr('min') ? parseInt(qtyInput.attr('min')) : 1,
                qtyIncrements = qtyInput.attr('step') ? parseInt(qtyInput.attr('step')) : 1;

            if($(this).hasClass('qtyplus')) {
                qty = (Math.ceil(origQty / qtyIncrements) * qtyIncrements) + qtyIncrements;
            } else {
                qty = (Math.ceil(origQty / qtyIncrements) * qtyIncrements) - qtyIncrements;
            }
            if(qty < minAllowed) {
                qty = minAllowed;
            }
            qtyInput.val(qty);
            if(qty != origQty) {
                qtyInput.trigger('change');
            }
        });
    };

    this.product = function () {
        if ($('body').hasClass('template-product')) {
            var staticProduct = $('[data-section-id="static-product"]').text();
            staticProduct = JSON.parse(staticProduct);
            app.productData.product = staticProduct.product;

            var form = $('[data-product-form]');
            if(window.Product) {
                if(window.Product.tierPrices) {
                    app.updateTierPrices();
                    $('[data-quantity-wrapper]').on('change','[name="quantity"]',function (e) {
                        var variants = $('select[name="id"]'),
                            qty = parseInt($(this).val()),
                            price = window.Product.price,
                            subscriptionPrice = (window.Product.price * .95),
                            qtyPriceContainers = $('[data-product-price-single]'),
                            priceContainers = $('.product-main [data-main-product-price]'),
                            subscriptionPriceContainers = $('.product-main [data-subscription-product-price]');
                        $.each(app.productData.tierPrices,function (index,priceData) {
                            if(qty >= priceData.min && qty <= priceData.max) {
                                price = priceData.price;
                                subscriptionPrice = (price * .95);
                                return false;
                            }
                        });
                        priceContainers.each((index, priceContainer) => {
                            $(priceContainer).html('<span class="main-price">$' + price + '</span>');
                        });
                        subscriptionPriceContainers.each((index, subscriptionPriceContainer) => {
                            $(subscriptionPriceContainer).text('$' + subscriptionPrice.toFixed(2));
                        });
                        qtyPriceContainers.each((index,qtyPriceContainer) => {
                            $(qtyPriceContainer).text('$' + price);
                        });
                        var variant = variants.find('[data-price="'+price+'"]');
                        if(variant) {
                            variants.val(variant.attr('value'));
                            variants.trigger('change');
                        }
                    });
                } else {
                    form.removeClass('loading');
                }
                //app.updateQtyDropdown();
            } else {
                form.removeClass('loading');
            }
        }
    };

    this.updateQtyDropdown = function () {
        var selectHtml = $('#product-quantity-select'),
            optionsHtml = '',
            minQty = window.Product.minCartQty,
            qtyInc = window.Product.qtyIncrements;
        optionsHtml = '<option selected="" value="'+minQty+'">'+minQty+'</option>';
        for (let step = 1; step <= 15; step++) {
            var qty = minQty + qtyInc * step;
            optionsHtml += '<option value="'+qty+'">'+qty+'</option>';
        }
        selectHtml.html(optionsHtml);
    };

    this.updateTierPrices = function () {
        var form = $('[data-product-form]'),
            productId = $('[name="product_id"]').val(),
            idField = form.find('[name="id"]'),
            priceMax = form.find('[name="product_price_max"]').val(),
            defVariant = form.find('[name="product_default_variant"]').val(),
            defSku = form.find('[name="product_default_sku"]').val(),
            selectEl = $('<select name="id" data-product-option></select>'),
            parentContainer = $('[data-product-tier-prices]'),
            innerHtml = $('<table><tr><th>Quantity</th><th>Price</th><th class="col-last">Discount</th></tr></table>'),
            prices = [],
            minQty = window.Product.minCartQty,
            total = 0;
        $.each(window.Product.tierPrices,function (qty,price) {
            prices.push({'qty':qty, 'price':price});
        });
        total = prices.length;
        const variants = app.productData.product.variants.filter(v => v.title !== 'Default Title');
        //app.getVariantsFromApi(defSku).then((variants) => {
        console.log(variants);
        if(variants.length !== total) {
            total = variants.length;
        }
        if(total > 0) {
            selectEl.append($('<option value="'+defVariant+'" data-price="'+priceMax+'" selected="selected">Default Title</option>'));
            $.each(variants,function (index,data) {
                if(typeof data === 'object' && data !== null) {
                    var qtyLabel = data.option1,
                        price = (data.price/100),
                        priceStr = price.toFixed(2),
                        productData = {min:0,max:0,price:0};
                    if(qtyLabel === 'Default Title') {
                        qtyLabel = minQty;
                    }
                    if(index < (total-1)) {
                        var nextTier = (parseInt(variants[index+1].option1) -1);
                        if(nextTier !== qtyLabel) {
                            qtyLabel = qtyLabel + ' - ' + (parseInt(variants[index+1].option1) -1);
                        } else {
                            qtyLabel = qtyLabel;
                        }
                        productData.min = parseInt(data.option1);
                        productData.max = parseInt(variants[index+1].option1) -1;
                        productData.price = priceStr;
                    } else {
                        qtyLabel += ' +';
                    }
                    if(index === 0) {
                        productData.min = parseInt(data.option1);
                    }
                    if(index === (total-1)) {
                        productData.min = parseInt(data.option1);
                        productData.max = 999999;
                        productData.price = priceStr;
                    }
                    var $tr = $('<tr>').append(
                        $('<td>').text(qtyLabel),
                        $('<td>').html('<strong>$'+ priceStr + '</strong> / ' + window.Product.unitOfMeasure),
                        $('<td class="col-last">').text(app.calculateDiscount(window.Product.price, price))
                    );
                    innerHtml.append($tr);
                    app.productData.tierPrices.push(productData);
                    selectEl.append($('<option value="'+data.id+'" data-price="'+priceStr+'">'+data.option1+'</option>'));
                }
            });
            //var $tr = $('<tr>').append($('<td colspan="3">').html('<a href="#" class="volume-popup-link" data-mfp-src="#contact-form-popup">Looking for larger quantities with deeper discounts?</a>'));
            //innerHtml.append($tr);
            console.log(app.productData.tierPrices);
            parentContainer.append(innerHtml);
            idField.replaceWith(selectEl);
            parentContainer.addClass('show');
            form.removeClass('loading');
            $('.volume-popup-link').magnificPopup({
                type:'inline'
            });
            setTimeout(function () {
                app.createRechargeWidget(productId);
            },1000);
        }
        //}).catch((error) => {
        //    console.log(error);
        //    form.removeClass('loading');
        //});
        console.log(window.Product.tierPrices);
    };

    this.createRechargeWidget = function (id) {
        if(app.productData.product !== undefined && app.productData.product.selling_plan_groups !== undefined) {
            const product = app.productData.product;
            const sellingPlans = product.selling_plan_groups[0].selling_plans;
            const price = (product.price_max / 100);
            const subscriptionPrice = (price * .95);
            console.log('product',product);
            let plansHtml = '<div class="subscriptions-wrapper tooltip-wrapper">\n' +
                '    <div class="subscription-types">\n' +
                '        <div>\n' +
                '            <input type="radio" name="purchase_type" value="onetime" id="purchase_type_onetime" checked>\n' +
                '            <label for="purchase_type_onetime">One-time purchase: <span data-main-product-price>$'+price.toFixed(2)+'</span></label>\n' +
                '        </div>\n' +
                '        <div>\n' +
                '            <input type="radio" name="purchase_type" value="subscription" id="purchase_type_subscription">\n' +
                '            <label for="purchase_type_subscription">Subscribe & Save (5%): <span data-subscription-product-price>$'+subscriptionPrice.toFixed(2)+'</span> <a href="#" class="learn-more-link">?</a></label>\n' +
                '            <div class="subscription-options">\n' +
                '                <label for="subscription-options">Deliver every</label>\n' +
                '            </div>\n' +
                '        </div>\n' +
                '    </div>\n' +
                '   <span class="tooltip-content">\n' +
                '       <a href="#" class="tooltip-close"></a>\n' +
                '       <strong>Choose how often it\'s delivered</strong>\n' +
                '       <span>From once per month to every four months</span>\n' +
                '       <br>\n' +
                '       <strong>Skip or cancel any time</strong>\n' +
                '       <span>Pause or cancel your auto-deliveries at any time</span>\n' +
                '   </span>' +
                '</div>\n';
            let options = '<select id="subscription-options" name="shipping_interval_frequency">';
            sellingPlans.forEach((sellingPlan, index) => {
                const planName = sellingPlan.name.replace('Delivery every ','');
                options += '<option value="'+sellingPlan.id+'">'+planName+'</option>';
            });
            options += '</select>';
            $('[data-product-form]').prepend($(plansHtml));
            $('[data-product-form] .subscription-options').append(options);
        }
    };

    this.getVariantsFromApi = function (sku) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: app.api.url + 'variants',
                type: 'POST',
                data: {
                    handle: window.Product.handle,
                    prices: window.Product.tierPrices,
                    qty: window.Product.availableQty,
                    sku: sku
                },
                success: function (data) {
                    resolve(data)
                },
                error: function (error) {
                    reject(error)
                },
            })
        })
    }

    this.calculateDiscount = function (oldPrice, newPrice) {
        if(newPrice > 0 && oldPrice > newPrice) {
            const price = Math.round(100 - ((100 / oldPrice) * newPrice));
            return 'Save ' + price.toFixed(0) + '%';
        } else {
            return '';
        }
    };
}

const wsbApp = new wineshippingboxesApp();
$(document).ready(() => {
    wsbApp.init();
});
